import { render } from "./RegisterMerchant.vue?vue&type=template&id=a2d58e82&scoped=true"
import script from "./RegisterMerchant.vue?vue&type=script&lang=js"
export * from "./RegisterMerchant.vue?vue&type=script&lang=js"

import "./RegisterMerchant.vue?vue&type=style&index=0&id=a2d58e82&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2d58e82"]])

export default __exports__